import { render, staticRenderFns } from "./HourGlass.vue?vue&type=template&id=2c1ac40a&scoped=true&"
import script from "./HourGlass.vue?vue&type=script&lang=js&"
export * from "./HourGlass.vue?vue&type=script&lang=js&"
import style0 from "./HourGlass.vue?vue&type=style&index=0&id=2c1ac40a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1ac40a",
  null
  
)

export default component.exports